<template>
  <line-chart
    class="fill-height"
    :raw-data="periods"
    :chart-value-keys="[
      { key: 'CALETLDLHSR', label: $t('chart_legends.hsr_distance'), type: 'bar' },
      { key: 'UXPCSEEF', label: $t('chart_legends.of_explosive_efforts') }
    ]"
    x-value="title"
    y-value-prefix="teams[0].team_stats."
    :yaxis="[
      { title: { text: $t('chart_legends.hsr_distance') }},
      { title: { text: $t('chart_legends.explosive_efforts') }, opposite: true }
    ]"
    :xaxis="{
      labels: {
        rotate: -45
      },
      tickPlacement: 'between'
    }"
    :colors="[ '#FF4560', '#775DD0' ]"
  >
    <template v-slot:header>
      <v-card-title class="pa-6">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.high_speed_running_and_explosive_efforts') }}
        </div>
      </v-card-title>
    </template>
  </line-chart>
</template>

<script>
import LineChart from '@/components/charts/LineChart'

export default {
  name: 'HighSpeedRunningPeriodChart',
  components: { LineChart },
  props: {
    periods: {
      type: Array,
      required: true
    },
    chart: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    }
  }
}
</script>
